// export const baseUrl = "http://192.168.1.12:5001";

export const baseUrl = "https://botbackend.technoloaderitservices.com";
